import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const ArrowRight: React.FC<IProps> = (props) => {
	return (
		<svg
			width="30"
			height="16"
			viewBox="0 0 30 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M28.9967 8.70711C29.3872 8.31658 29.3872 7.68342 28.9967 7.29289L22.6327 0.928932C22.2422 0.538408 21.609 0.538408 21.2185 0.928932C20.828 1.31946 20.828 1.95262 21.2185 2.34315L26.8753 8L21.2185 13.6569C20.828 14.0474 20.828 14.6805 21.2185 15.0711C21.609 15.4616 22.2422 15.4616 22.6327 15.0711L28.9967 8.70711ZM0.289551 9H28.2896V7H0.289551V9Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default memo(ArrowRight);
